import React from "react";
import { Col, Modal, Row, Form } from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { exportEmails } from "../../../store/emails/actions";
import { useDispatch } from "react-redux";

// Update the validation schema to validate a string (month)
const schema = yup.object().shape({
  month: yup.string(),
  year: yup.number().required("Year is required"),
});

export default function EmailsExport({
  modal_export,
  tog_export,
  setmodal_export,
}) {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (formData) => {
    dispatch(exportEmails({ formData }));

    if (!Object.keys(errors).length) {
      setmodal_export(false);
    }
  };

  return (
    <Modal
      isOpen={modal_export}
      toggle={() => {
        tog_export();
      }}
      centered
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          style={{ display: "flex", alignItems: "center" }}
        >
          <i className="ri-mail-line" style={{ paddingRight: 5 }}></i> Export
          Emails
        </h5>
        <button
          type="button"
          onClick={() => {
            setmodal_export(false);
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-2">
            <Col md="12" className="mb-2">
              <div className="field">
                {/* Replace the input field with a select input */}
                <select
                  {...register("month")}
                  className={`form-control ${errors.month ? "is-invalid" : ""}`}
                >
                  <option value="">Select Month</option>
                  <option value="1">January</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
                {errors.month && (
                  <div className="invalid-feedback">{errors.month.message}</div>
                )}
              </div>
            </Col>
            <Col md="12" className="mb-2">
              <div className="field">
                {/* Replace the input field with a select input */}
                <input
                  type="number"
                  placeholder="Select the year"
                  style={{ padding: "16px 12px 16px 12px" }}
                  {...register("year")}
                  defaultValue={2024}
                  className={`form-control ${errors.year ? "is-invalid" : ""}`}
                />

                {errors.year && (
                  <div className="invalid-feedback">{errors.year.message}</div>
                )}
              </div>
            </Col>
          </Row>

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-lg btn-secondary"
              onClick={() => {
                setmodal_export(false);
              }}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-lg btn-primary">
              Export
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
